import * as React from 'react';
import type { SVGProps } from 'react';
const SvgPaywall3Star = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      fill="currentColor"
      d="M10.27 4.875 8 .118 5.73 4.875l-5.226.69 3.823 3.628-.96 5.183L8 11.862l4.632 2.514-.96-5.183 3.823-3.629z"
    />
  </svg>
);
export default SvgPaywall3Star;
